import { SectionHeading, FadeUp } from "./Reveal";

export const AboutText = () => (
  <section data-testid="about-text-section" className="py-24 sm:py-28">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <SectionHeading
          testId="about-text"
          overline="About JIYONOX"
          title={<>One technology partner across <span className="jx-gradient-text">AI, software and cloud.</span></>}
        />
      </div>
      <div className="lg:col-span-7 space-y-6">
        <FadeUp delay={0.1}>
          <p className="text-base sm:text-lg leading-relaxed text-jx-ink/70">
            JIYONOX is an AI consulting and custom software development company helping organizations turn
            intelligence into measurable business outcomes. Our teams design and engineer AI solutions that go far
            beyond demos — from AI agents and agentic AI workflows that execute real work, to enterprise AI
            platforms with retrieval-augmented generation, governance and analytics built in. Every engagement
            starts with your business goals and ends with production-grade systems your teams can rely on.
          </p>
        </FadeUp>
        <FadeUp delay={0.18}>
          <p className="text-base sm:text-lg leading-relaxed text-jx-ink/70">
            As a full-stack software engineering and cloud engineering partner, we build web applications,
            enterprise portals, commerce platforms and SaaS development programs on AWS, Azure and Google Cloud —
            then operate them with DevOps, observability and reliability engineering. Our business automation and
            workflow automation practice replaces repetitive operations with intelligent, autonomous systems:
            document intelligence, sales and customer-service AI, marketing automation and enterprise workflow
            automation, all connected to the CRM, ERP and data platforms you already run.
          </p>
        </FadeUp>
        <FadeUp delay={0.26}>
          <p className="text-base sm:text-lg leading-relaxed text-jx-ink/70">
            For digital experience and digital transformation programs, JIYONOX delivers AEM consulting, digital
            asset management, content supply chain modernization, personalization, search and SEO automation —
            helping enterprises, associations, healthcare organizations, events and commerce brands operate
            smarter, move faster and grow with confidence. From intelligence to impact: that is the standard we
            engineer to.
          </p>
        </FadeUp>
        <FadeUp delay={0.32}>
          <div className="flex flex-wrap gap-2 pt-2">
            {["AI consulting", "AI agents", "Custom software development", "Business automation", "Cloud engineering", "Enterprise AI", "AEM consulting", "Digital experience", "SaaS development", "Digital transformation"].map((k) => (
              <span key={k} className="rounded-full bg-jx-mist border border-jx-ink/6 px-3.5 py-1.5 text-xs font-semibold text-jx-ink/60" data-testid={`about-keyword-${k.toLowerCase().replace(/\s+/g, "-")}`}>
                {k}
              </span>
            ))}
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
